/* ═══════════════════════════════════════════════════════════════
   CASE STUDY DETAIL PAGE — ADDITIONAL JS
   Add this AFTER your main script.js (or paste at bottom of it)
   ═══════════════════════════════════════════════════════════════ */

// ═══ COUNTER ANIMATION (Case Study specific — supports floats) ═══
const csCounterObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    const rawTarget = el.dataset.target || '0';
    const suffix = el.dataset.suffix || '';
    const isFloat = rawTarget.includes('.');
    const target = parseFloat(rawTarget);
    const duration = 1800;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      el.textContent = (isFloat ? current.toFixed(1) : Math.floor(current)) + suffix;
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = (isFloat ? target.toFixed(1) : target) + suffix;
    }

    requestAnimationFrame(update);
    csCounterObserver.unobserve(el);
  });
}, { threshold: 0.5 });

document.querySelectorAll('[data-target]').forEach(el => csCounterObserver.observe(el));


// ═══ BAR CHART ANIMATION (Case Study dark bars) ═══
const csBarObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('.bar, .cs-bar-col').forEach((bar, i) => {
      setTimeout(() => bar.classList.add('anim'), i * 120);
    });
    csBarObserver.unobserve(entry.target);
  });
}, { threshold: 0.3 });

document.querySelectorAll('.bar-chart, .cs-bar-chart').forEach(el => csBarObserver.observe(el));


// ═══ LINE CHART ANIMATION (SVG stroke draw) ═══
const csLineObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.querySelectorAll('.lp').forEach(p => p.classList.add('anim'));
    entry.target.querySelectorAll('.af').forEach(a => setTimeout(() => a.classList.add('anim'), 500));
    entry.target.querySelectorAll('.dd').forEach(d => {
      setTimeout(() => d.classList.add('anim'), parseInt(d.dataset.delay || 0));
    });
    csLineObserver.unobserve(entry.target);
  });
}, { threshold: 0.3 });

document.querySelectorAll('.lcw, .cs-line-wrap').forEach(el => csLineObserver.observe(el));


// ═══ REVEAL ON SCROLL (for .cs- sections if not already covered) ═══
const csRevealObserver = new IntersectionObserver((entries) => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) {
      setTimeout(() => e.target.classList.add('visible'), i * 60);
      csRevealObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

document.querySelectorAll('.reveal, .stagger-children').forEach(el => csRevealObserver.observe(el));
